<template>
  <Modal v-model="connectionLost" :dismissable="false">
    <p class="font-bold leading-tight pb-2 text-xl">
      {{ $t('popups.lostConnection.title') }}
    </p>
    <p class="text-sm leading-tight pb-5 xl:pb-8">
      {{ $t('popups.lostConnection.description', brandInfo) }}
    </p>
    <div class="flex">
      <Button
        :href="backToLHLink"
      >
        {{ $t('popups.lostConnection.returnToLHButton', brandInfo) }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import LostConnectionPopup from '~app/psp/base/lost-connection-popup.ts'
import Button from '~brand-components/austrian/button/button.vue'
import Modal from '~brand-components/austrian/modal/modal.vue'

export default LostConnectionPopup.extend({
  components: {
    Modal,
    Button,
  },
})
</script>
